<app-modal *ngIf="vo$ | async; let vo" (triggerClose)="close()">
	<div modal-body>
		<mat-stepper
			[linear]="true"
			[selectedIndex]="vo.currentStep"
			(selectionChange)="changeCurrentStep($event)"
			(animationDone)="onStepReady()"
		>
			<mat-step
				[completed]="vo.structureValidity.length === 0"
			>
				<ng-template matStepLabel>
					<span
						i18n="@@depot.headers.mapping.stepper.selection">
						headers-selection</span>
				</ng-template>
				<ng-container>
					<div class="depot-structure-options-container">
						<div class="depot-structure-viewer-options">
							<div class="viewer-option__collapseActions">
								<app-button id="{{cmpId}}-expand-trigger-btn" [leftIcon]="DcIcons.ExpandAll" (click)="isExpanded = true"
														matTooltip="expand-all" i18n-matTooltip="@@depot.allExpanded"></app-button>

								<app-button id="{{cmpId}}-collapse-trigger-btn" [leftIcon]="DcIcons.CollapseAll" (click)="isExpanded = false"
														matTooltip="collapse-all" i18n-matTooltip="@@depot.allCollapsed"></app-button>
							</div>

							<div class="viewer-option__selectionActions">
								<app-button id="{{cmpId}}-selectAll-leafs-trigger-btn" [leftIcon]="DcIcons.SelectAll" (click)="hasAllLeafsSelected = true"
														matTooltip="select-all" i18n-matTooltip="@@depot.allLeafsSelected"></app-button>

								<app-button id="{{cmpId}}-deselectAll-leafs-trigger-btn" [leftIcon]="DcIcons.DeSelectAll" (click)="hasAllLeafsSelected = false"
														matTooltip="deselect-all" i18n-matTooltip="@@depot.allLeafsDeSelected"></app-button>
							</div>

							<div class="viewer-option__labelActions">
								<app-button id="{{cmpId}}-auto-remove-duplicates-btn" [leftIcon]="DcIcons.DetectAnomalies" (click)="triggerAutoRemoveDuplicates()"
														matTooltip="depot-auto-remove-duplicates" i18n-matTooltip="@@depot.autoRemoveDuplicates"></app-button>

								<app-button id="{{cmpId}}-trigger-reset-labels-btn" [leftIcon]="DcIcons.ResetText" (click)="triggerResetLabels()"
														matTooltip="depot-reset-labels" i18n-matTooltip="@@depot.resetLabels"></app-button>

								<app-button id="{{cmpId}}-trigger-schema-detection-btn" [leftIcon]="DcIcons.FixWizard" (click)="triggerReplaceWithPath()"
														matTooltip="depot-replace-label-path" i18n-matTooltip="@@depot.replaceLabelWithPath"></app-button>
							</div>

							<div class="viewer-option__schemaAction">
								<app-button id="{{cmpId}}-trigger-schema-detection-btn" [leftIcon]="DcIcons.DetectSchema" (click)="triggerSchemaDetection()"
														matTooltip="detect-schema" i18n-matTooltip="@@depot.detectSchema"></app-button>

							</div>

							<div class="viewer-option__search">
								<form class="depot-search-term__form">
									<!--			search field				-->
									<mat-form-field class="depot-search-term__form-input" appearance="fill">
										<mat-label i18n="@@depot.searchTerm">search-term</mat-label>
										<input name="searchTerm" matInput placeholder="leaf-name" i18n-placeholder="@@depot.leafName"
													 [(ngModel)]="structureSearchTerm" (keydown.enter)="triggerReplaceField($event, false)">
										<button id="search" matPrefix mat-icon-button aria-label="search" (click)="triggerReplaceField($event, true)">
											<mat-icon>find_replace</mat-icon>
										</button>
										<button *ngIf="structureSearchTerm" matSuffix mat-icon-button aria-label="clear-search" (click)="structureSearchTerm=''">
											<mat-icon>close</mat-icon>
										</button>
									</mat-form-field>

									<!--			replace field				-->
									<mat-form-field *ngIf="replaceWith" class="depot-search-term__form-input" appearance="fill">
										<mat-label i18n="@@depot.replaceWith">replaceWith</mat-label>
										<input name="replaceWith" matInput placeholder="leaf-replace-name" i18n-placeholder="@@depot.leafName.replaceWith"
													 [(ngModel)]="structureReplaceWithTerm" (keydown.enter)="triggerReplaceNameWith($event, structureSearchTerm, structureReplaceWithTerm)">
										<button id="replace" matPrefix mat-icon-button aria-label="replace" (click)="triggerReplaceNameWith($event, structureSearchTerm, structureReplaceWithTerm)">
											<mat-icon>published_with_changes</mat-icon>
										</button>
										<button *ngIf="structureReplaceWithTerm" matSuffix mat-icon-button aria-label="clear-replace" (click)="structureReplaceWithTerm=''">
											<mat-icon>close</mat-icon>
										</button>
									</mat-form-field>
								</form>
							</div>

							<div class="viewer-option__doc">
								<app-nav-doc [navigateToUrl]="FunctionalDocumentationKeys.DEPOT_HEADERS_MAPPING">
								</app-nav-doc>
							</div>
						</div>
					</div>

					<div class="depot-structure-selected-headers-container" [class.is-visible]="vo.selectedHeaders.length !== 0"
							 [class.is-mini-viewer-hidden]="!vo.isMiniViewerActive">
						<div class="depot-structure-selected-headers-container-title">
							<span>{{vo.selectedHeaders.length}}</span>
							<span i18n="@@depot.headers-selection" class="">current-selection</span>
							<button class="mini-viewer-toggle" mat-icon-button aria-label="hide-mini-viewer" (click)="toggleSelectionViewer()">
								<mat-icon *ngIf="vo.isMiniViewerActive">expand_less</mat-icon>
								<mat-icon *ngIf="!vo.isMiniViewerActive">expand_more</mat-icon>
							</button>
						</div>
						<div class="depot-structure-selected-headers">
							<ng-container *ngFor="let header of vo.selectedHeaders; last as isLast">
								<div class="selected-header">
									<ng-container [ngTemplateOutlet]="structType"
																[ngTemplateOutletContext]="{$implicit: header}"></ng-container>
									<span appHighlight [searchTerm]="structureSearchTerm"
												[text]="header.currentLabel !== '' ? header.currentLabel : header.path"></span>
								</div>
								<mat-divider *ngIf="!isLast"></mat-divider>
							</ng-container>
						</div>
					</div>

					<ng-container *ngIf="!vo.headers">
						<div class="is-loading depot-structure">
							<span i18n="@@depot.ongoing-schema-detection">ongoing-depot-schema-detection</span>
							<mat-spinner color="accent" diameter="75"></mat-spinner>
						</div>
					</ng-container>

					<app-depot-schema *ngIf="vo.headers" class="depot-structure" [class.depot-structure--has-replace-active]="replaceWith" [structure]="vo.headers"
														 [searchTerm]="structureSearchTerm" [selectLeafs]="hasAllLeafsSelected"
														 [expandAll]="!isExpanded" [replaceDuplicates]="autoRemoveDuplicates"
														 [resetLabels]="resetLabels" [replaceWithPath]="replaceWithPath"
														 [collapseAll]="isExpanded" (structureValidity)="updateValidity($event)"
														 (selectedHeaders)="retrieveSelectedHeaders($event)"></app-depot-schema>
				</ng-container>
			</mat-step>
			<mat-step>
				<ng-template matStepLabel>
					<span
						i18n="@@depot.headers.mapping.stepper.settings">
						headers-settings</span>
				</ng-template>

				<app-panel
					headerHeight="3.25rem"
					isAlwaysOpen="true"
					[itemsCount]="vo.depotMappingElements.size"
					[actions]="vo.panelActions">
					<div panel-title class="app-panel__title">
						<span i18n="@@depot.header.mapping.settings">settings-types</span>
					</div>
					<span panel-info>
						<ng-container
							*ngIf="vo.settingErrors > 0">
							<div class="columns-alert error">
								<mat-icon [svgIcon]="DcIcons.Warning"></mat-icon>
								{{ vo.settingErrors }}
								<span i18n="@@depot.header.mapping.errors.line.invalid">
									 lines-invalid
								</span>
							</div>
						</ng-container>
					</span>
					<ng-container *ngTemplateOutlet="depotMapping"></ng-container>
				</app-panel>

			</mat-step>
		</mat-stepper>
	</div>

	<div modal-footer class="app-depot-header-mapping__footer">
		<div *ngIf="vo.structureValidity.length !== 0" class="invalidity-msg">
			<mat-icon [svgIcon]="DcIcons.WarningMessage"></mat-icon>
			<span *ngFor="let e of vo.structureValidity">{{e}}</span>
		</div>

		<button
			*ngIf="vo.currentStep === DepotHeaderStep.Settings"
			id="{{cmpId}}-back-btn"
			[color]="'primary'"
			mat-raised-button
			(click)="backStep()">
			<span i18n="@@general.stepper.back">Back</span>
		</button>

		<button
			*ngIf="vo.currentStep === DepotHeaderStep.Selection"
			id="{{cmpId}}-next-btn"
			[color]="'primary'"
			[disabled]="vo.structureValidity.length !== 0"
			mat-raised-button
			(click)="nextStep()">
			<span i18n="@@general.stepper.next">Next</span>
		</button>

		<button
			*ngIf="vo.currentStep === DepotHeaderStep.Settings"
			id="{{ cmpId }}-save-btn"
			[color]="'primary'"
			class="app-depot-header-mapping__footer__btn"
			mat-raised-button
			[disabled]="vo.settingErrors !== 0"
			(click)="save()">
			<span i18n="@@depot.action.save">update</span>
		</button>
	</div>



	<ng-template #depotMapping>
		<dx-data-grid
			*ngIf="vo.depotMappingList.availableColumns.size !== 0"
			keyExpr="config.id"
			[elementAttr]="{
										id: 'depot-header-mapping-list',
										class: 'app-depot-header-mapping'
								}"
			[repaintChangesOnly]="true"
			[dataSource]="vo.depotMappingElements| toArray"
			[hoverStateEnabled]="true"
			[showColumnHeaders]="true"
			[allowColumnResizing]="true"
			[columnAutoWidth]="false"
			[showRowLines]="false"
			[showColumnLines]="false"
			[rowAlternationEnabled]="false"
			[showBorders]="false"
			[selection]="{ mode: 'none' }"
			[width]="'100%'"
			[filterValue]="filterValue"
			(onOptionChanged)="onGridOptionChanged($event)">

			<dxo-row-dragging
				[allowReordering]="vo.allowReordering"
				[onReorder]="onReorder"
				[showDragIcons]="true"
			></dxo-row-dragging>

			<dxo-scrolling mode="virtual"></dxo-scrolling>

			<!-- Fixable in position columns	-->
			<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

			<dxo-load-panel
				shadingColor="rgba(0,0,0,0)"
				[indicatorSrc]="DcLoaders.LoaderInfinite"
				[height]="100"
				[width]="100"
				[enabled]="true"
				[showIndicator]="true"
				[showPane]="true"
				[shading]="true"></dxo-load-panel>

			<ng-container
				*ngFor="let col of vo.depotMappingList.availableColumns | toArray">
				<dxi-column
					*ngIf="col.field === 'label'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[visibleIndex]="col.visibleIndex"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="false"
					[alignment]="'left'"
					[allowEditing]="true"
					[visible]="col.visible"
					[calculateCellValue]="getLabel"
					[width]="'25%'"
					cellTemplate="labelTemplate"></dxi-column>

				<dxi-column
					*ngIf="col.field === 'dataType'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[visibleIndex]="col.visibleIndex"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="false"
					[alignment]="'left'"
					[allowEditing]="false"
					[visible]="col.visible"
					[calculateCellValue]="getDataType"
					[width]="'5%'"
					cellTemplate="dataTypeTemplate"></dxi-column>

				<dxi-column
					*ngIf="col.field === 'convertTo'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[visibleIndex]="col.visibleIndex"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="false"
					[alignment]="'left'"
					[allowEditing]="false"
					[visible]="col.visible"
					[width]="'25%'"
					cellTemplate="convertToTemplate"></dxi-column>

				<dxi-column
					*ngIf="col.field === 'format'"
					[dataField]="col.field"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[visibleIndex]="col.visibleIndex"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="false"
					[alignment]="'left'"
					[allowEditing]="false"
					[visible]="col.visible"
					[width]="'42%'"
					cellTemplate="formatTemplate"></dxi-column>
			</ng-container>

				<dxi-column
					dataField="labelError"
					[visible]="false"></dxi-column>

			<div *dxTemplate="let cell of 'labelTemplate'">
				<dx-text-box
					 [value]="cell.data.config['label']"
					 [validationStatus]="cell.data['labelStatus']"
					 [validationError]="{ message: cell.data['labelError'] }">
					<dx-validator (onValidated)="updateHeaderLabel(cell.key, $event)">
						<dxi-validation-rule
							type="required"
							message="this field is required!"
							i18n-message="@@general.form.errors.required"></dxi-validation-rule>
						<dxi-validation-rule
							type="async"
							[reevaluate]="true"
							[validationCallback]="validateDuplicate"
							message="Duplicate labels are not allowed"
							i18n-message="@@depot.duplicateLabel">
						</dxi-validation-rule>
					</dx-validator>
				</dx-text-box>
			</div>

			<div *dxTemplate="let cell of 'dataTypeTemplate'">
				<div class="data-type-template">
					<app-column-type
						[type]="cell.data.config['convertTo'] ?? cell.data.config['savedType']"
						[isList]="cell.data.config['isList']"
					></app-column-type>

					<app-overlay-badge
						*ngIf="cell.data.config['previousLabel'] !== cell.data.config['label']
								|| (cell.data.config['dataType'] !== ColumnType.Unknown && cell.data.config['convertTo'] && cell.data.config['dataType'] !== cell.data.config['convertTo'])"
						id="{{cell.data['id']}}-header-details-overlay"
						[active]="true"
						[icon]="DcIcons.Info"
						[iconNamespace]="''"
						[isOpen]="vo.openedOverlays.detailsHeaderId === cell.data.config['id']"
						(overlayDismiss)="closeOverlay()"
						(click)="openHeaderDetailsPopover($event, cell.data.config['id'])">
						<app-popover
							id="header-details-popover"
							overlayContent
							title="header"
							i18n-title="@@depot.header.mapping.popover.title"
							[icon]="{ iconName: DcIcons.Info }"
							[iconNamespace]="''"
							(adbPopoverClose)="closeOverlay()">
							<div
								class="entry"
								*ngIf="cell.data.config['previousLabel'] !== cell.data.config['label']">
								<span class="entry-label"
											i18n="@@depot.header.mapping.popover.previousLabel">previous-label</span>
								<span>{{ cell.data.config['previousLabel'] }}</span>
							</div>
							<div
								class="entry"
								*ngIf="cell.data.config['dataType'] !== ColumnType.Unknown && cell.data.config['dataType'] !== cell.data.config['convertTo']">
								<span class="entry-label"
											i18n="@@depot.header.mapping.popover.originalType">original-type</span>
								<app-column-type
									[type]="cell.data.config['dataType']"
									[isList]="cell.data['isList']"></app-column-type>
							</div>
							<!--<div
								class="entry"
								*ngIf="cell.data.config['dataType'] !== cell.data.config['savedType']">
								<span class="entry-label"
											i18n="@@depot.header.mapping.popover.saveType">save-type</span>
								<app-column-type
									[type]="cell.data.config['savedType']"
									[isList]="cell.data['isList']"></app-column-type>
							</div>-->
						</app-popover>
					</app-overlay-badge>
				</div>
			</div>

			<div *dxTemplate="let cell of 'convertToTemplate'">
				<dx-select-box
					[ngClass]="{'depot-header-type--is-modified': cell.data.config['savedType'] !== cell.data.config['dataType'] }"
					[dataSource]="cell.data.config['dataType'] | toCompatibleTypeMapping"
					[value]="cell.data.config['convertTo'] ?? cell.data.config['savedType']"
					[disabled]="!cell.data['canBeMapped']"
					valueExpr="value"
					displayExpr="label"
					(onValueChanged)="selectConvertTo(cell.key, $event)"></dx-select-box>
			</div>

			<div *dxTemplate="let cell of 'formatTemplate'">
				<div
					class="depot-mapping-date-format"
					*ngIf="(cell.data.config['convertTo'] === ColumnType.Date && (
					cell.data.config['dataType'] === ColumnType.Str)) ||
					 (cell.data.config['convertTo'] === ColumnType.Str && (
					cell.data.config['dataType'] === ColumnType.Date))">
					<dx-select-box
						placeholder="select-format"
						i18n-placeholder="@@depot.header.mapping.select.date.format"
						[dataSource]="vo.availableDateFormats | toArray"
						[value]="cell.data.config['format']"
						[disabled]="!cell.data['canBeMapped']"
						[searchEnabled]="true"
						valueExpr="value"
						displayExpr="label"
						(onValueChanged)="selectFormat(cell.key, $event)"></dx-select-box>

					<dx-select-box
						placeholder="select-timezone"
						i18n-placeholder="@@depot.header.mapping.select.timezone"
						[dataSource]="vo.availableTimezones"
						[value]="cell.data.config['timezone']"
						[disabled]="!cell.data['canBeMapped']"
						[searchEnabled]="true"
						(onValueChanged)="selectTimezone(cell.key, $event)"></dx-select-box>

					<dx-select-box
						placeholder="select-language"
						i18n-placeholder="@@depot.header.mapping.select.language"
						[dataSource]="vo.supportedLanguages | toArray"
						[value]="cell.data.config['language']"
						[disabled]="!cell.data['canBeMapped']"
						[searchEnabled]="true"
						valueExpr="key"
						displayExpr="label"
						(onValueChanged)="selectLanguage(cell.key, $event)"></dx-select-box>
				</div>


				<dx-select-box
					*ngIf="
							(cell.data.config['format'] && (
										(cell.data.config['convertTo'] === ColumnType.Str && cell.data.config['dataType'] === ColumnType.Dec) ||
										 (cell.data.config['convertTo'] === ColumnType.Dec && cell.data.config['dataType'] === ColumnType.Str)
							 	))"
					placeholder="select-number-format"
					i18n-placeholder="@@depot.header.mapping.select.number.format"
					[dataSource]="AvailableNumberFormats"
					[value]="cell.data.config['format']"
					[disabled]="!cell.data['canBeMapped']"
					valueExpr="code"
					displayExpr="lib"
					(onValueChanged)="selectFormat(cell.key, $event)"></dx-select-box>
			</div>

			<!-- Filterable columns	-->
			<dxo-filter-row
				[visible]="vo.depotMappingList.availableColumns.size !== 0"></dxo-filter-row>

			<dxo-group-panel [visible]="false"></dxo-group-panel>

			<!-- Search input -->
			<dxo-search-panel [visible]="false"></dxo-search-panel>

			<!-- Sorting	-->
			<dxo-sorting mode="single"></dxo-sorting>

			<!-- Pagination -->
			<dxo-paging [pageSize]="1000"></dxo-paging>

			<dxo-pager [visible]="false"></dxo-pager>

			<!-- State persistence	-->
			<dxo-state-storing
				type="localStorage"
				[enabled]="false"
				[storageKey]="dxLocalStorageKey"></dxo-state-storing>

		</dx-data-grid>
	</ng-template>
</app-modal>

<ng-template #structType let-entry>
	<!-- Array entry   -->
	<ng-container *ngIf="entry.schemaElemType === DataStruct.Array">
		<mat-icon>data_array</mat-icon>
	</ng-container>

	<!-- Structure entry   -->
	<ng-container *ngIf="entry.schemaElemType === DataStruct.Struct">
		<mat-icon>data_object</mat-icon>
	</ng-container>

	<!-- Leaf entry   -->
	<ng-container *ngIf="entry.schemaElemType === DataStruct.Leaf">
		<ng-container *ngIf="!entry.convertTo || entry.convertTo === entry.dataType">
			<app-column-type [type]="entry.dataType" [tooltipDisabled]="true"></app-column-type>
		</ng-container>
		<ng-container *ngIf="entry.convertTo && entry.convertTo !== entry.dataType">
			<app-column-type [type]="entry.dataType" [tooltipDisabled]="true"></app-column-type>
			<mat-icon>arrow_forward</mat-icon>
			<app-column-type [type]="entry.convertTo" [tooltipDisabled]="true"></app-column-type>
		</ng-container>
	</ng-container>
</ng-template>
